<!-- SG-7046 start-->
<div class="flex-class">

    <div class="child-block">
        <mat-card style="margin-right: 10px;height: 100%;">
            <!-- ******* SG-7046  ******************-->
            <span class="mission-heading" >Lesson Records</span>
            <!-- <div>
            <div class="content-center bottom-space top-space">

                <div class="circle-blue  top-circle">
                    {{countAPIData?.sessionCount}}
                </div>
                <span class="text-class" style="margin-top: 5px;"> Session Count </span>
            </div>
            <div class="content-center1 bottom-space">
                <div class="aligning-box">
                    <div class="circle-green circle-data-green bottom-circle">
                        {{countAPIData?.clearedCount}}
                    </div>
                    <span class="text-class"> Cleared Count </span>
                </div>
                <div class="aligning-box">
                    <div class="circle-red circle-data-red bottom-circle1">{{countAPIData?.notClearedCount}}</div>
                    <span class="text-class"> Not Cleared Count </span>
                </div>
            </div>
            </div> -->
            <!-- ***************SG-7046 start************ -->
            <div class="ele-place" fxLayout="column" fxFlex="100%" fxLayoutAlign="center center">
                <div class="flx" fxLayout="column" fxFlex="50%" fxLayoutAlign="center center" style="padding-bottom: 25px;">
            <div class="img-circle" id="parentElement" fxLayoutAlign="center center" fxLayout="column" style="text-align: center;"  [style.height.px]="getDynamicHeight()">
                {{countAPIData?.sessionCount}}
                <!-- 333333333 -->
               </div> 
               <span style="text-align: center;" class="text-class">Session Count</span>
            </div>
            
            <div fxLayout="column" fxFlex="100%">
                <div fxLayout="row" fxFlex="100%" fxLayoutAlign="space-between baseline">

                    <div class="flx" fxLayout="column" fxFlex="50%" fxLayoutAlign="center center">
                        <div class="cleared-img-circle" id="parentElement2" fxLayoutAlign="center center" fxLayout="column" style="text-align: center;" [style.height.px]="getDynamicHeight2()">
                            {{countAPIData?.clearedCount}}
                        </div>
                        <span style="text-align: center;color: #2D8656" class="text-class">Cleared Count</span>
                    </div>
                    <div class="flx" fxLayout="column" fxFlex="50%" fxLayoutAlign="center center" style="color: #C73535 !important;">
                        <div class="Rejected-img-circle" id="parentElement1" fxLayoutAlign="center center" fxLayout="column" style="text-align: center;" [style.height.px]="getDynamicHeight1()">
                            {{countAPIData?.notClearedCount}}
                        </div>
                        <span style="text-align: center;color: #BE1515;" class="text-class">Not Cleared Count</span>
                    </div>
                </div>
            </div>
            <!--**************** SG-7046 end ***************** -->
        </div>
        </mat-card>
    </div>

    <div class="child-block1">
        <mat-card style="height: 100%;">
            <mat-card-header class="card-head">
                <div class="export-icon"> <span class="mission-heading"> {{lessonName}} Records</span>

                    <i class="fa fa-share-square-o" aria-hidden="true"
                        style="font-size: 24px;margin-top:10px; color: #707070; cursor: pointer;"
                        (click)="exportCsvData('performance')"></i>
                </div>
            </mat-card-header>
            <div class="table-class">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" width="100%">


                    <ng-container matColumnDef="levelType">
                        <!--  ************* SG-7046 ******************-->
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="20%"> Level Type </th>
                        <td style="padding: 0px !important;text-align: justify;" mat-cell *matCellDef="let element" [matTooltip]="element?.levelType == 'Level 4'? 'Challenge':element?.levelType" pointer (click)="openUserDialog(element)">
                           <a class="underline"> {{element?.levelType == 'Level 4'? 'Challenge':element?.levelType}}</a> </td>
                    </ng-container>
                    <ng-container matColumnDef="sessionsPlayed">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="15%"> Sessions </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.sessionsPlayed" pointer>
                            {{element?.sessionsPlayed}} </td>
                    </ng-container>
                    <ng-container matColumnDef="excellentHits">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="15%"> Excellent Hits </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.excellentHits" pointer>
                            {{element?.excellentHits}} </td>
                    </ng-container>
                    <ng-container matColumnDef="goodHits">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="15%"> Good Hits </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.goodHits" pointer>
                            {{element?.goodHits}} </td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="goodHits">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="17%"> Good Hits </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.goodHits" pointer>
                            {{element.goodHits}} </td>
                    </ng-container>  -->
                    <ng-container matColumnDef="missedHits">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="15%"> Missed Hits </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.missedHits" pointer>
                            {{element?.missedHits}} </td>
                    </ng-container>
                    <ng-container matColumnDef="voiceCommands">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="15%"> Voice Commands </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.voiceCommands" pointer>
                            {{element?.voiceCommands}} </td>
                    </ng-container>

                    <ng-container matColumnDef="textCommands">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="15%"> Text Commands </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.textCommands" pointer>
                            {{element?.textCommands}} </td>
                    </ng-container>


                    <ng-container matColumnDef="clearedCount">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="15%"> Cleared </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.clearedCount" pointer>
                            {{element?.clearedCount}} </td>
                    </ng-container>

                    <ng-container matColumnDef="notClearedCount">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="15%"> Not Cleared </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.notClearedCount" pointer>
                            {{element?.notClearedCount}} </td>
                    </ng-container>
                    <ng-container matColumnDef="percentageCorrect">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="15%"> % Correct </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.percentageCorrect" pointer>
                            {{element?.percentageCorrect}}% </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>

                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" pointer></tr>
                </table>
            </div>
            <!-- <mat-paginator [pageSizeOptions]="[5,10, 25, 50]" [pageSize]="pageSize" [length]="missionRecords.length"
                (page)="onPageChange($event)"></mat-paginator> -->

        </mat-card>
    </div>

</div>

<div fxLayout="row" [ngClass]="['card-height']" fxLayoutAlign="space-between" fxLayoutGap="10px">
    <mat-card class="flx-card wd-mx crd-ovrflw bottom-card-ht">
        <mat-card-header class="grp_hdr">
            <article [ngClass]="['header-padding']">
                <div fxLayout="column" fxLayoutAlign="start center">
                    <h4 ngClass="selectlist-label" *ngIf="dateType?.type == 'month' || dateType?.type == 'Month'">Last 24
                        Month's Data</h4>
                    <h4 ngClass="selectlist-label" *ngIf="dateType?.type == 'day' || dateType?.type == 'Day'">Last 1
                        Month's Data</h4>
                    <h4 ngClass="selectlist-label" *ngIf="dateType?.type === 'year' || dateType?.type === 'Year'">Last 5
                        Year's Data</h4>
                </div>
                <nav class="nv_rt rpd">
                    <div fxLayout="row" fxLayoutGap="10px">
                        <div fxLayout="column" fxLayoutAlign="end center">
                            <div fxLayout="row">
                                <h4 ngClass="selectlist-label"
                                    *ngIf="usageAnalyticsSelectedValue !== 'totalPlayedSession' &&
                            usageAnalyticsSelectedValue !== 'averageDuration' &&
                            usageAnalyticsSelectedValue!=='masteredPracticeSets' && usageAnalyticsSelectedValue === 'All'">
                                    Usage : </h4>
                                <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'TotalMissions'">
                                    Total Missions Sessions :
                                </h4>
                                <h4 ngClass="selectlist-label"
                                    *ngIf="usageAnalyticsSelectedValue === 'AvgMissionDuration'">Average Mission
                                    Duration :
                                </h4>
                                <h4 ngClass="selectlist-label"
                                    *ngIf="usageAnalyticsSelectedValue === 'ClearedMissions'">Total Cleared Missions :
                                </h4>

                                <h4 ngClass="selectlist-label"
                                    *ngIf="usageAnalyticsSelectedValue === 'NotClearedMissions'">Total Not Cleared
                                    Missions :
                                </h4>
                                <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'VoiceCommands'">
                                    Total Voice Commands :
                                </h4>
                                <h4 ngClass="selectlist-label" *ngIf="usageAnalyticsSelectedValue === 'TextCommands'">
                                    Total Text Commands :
                                </h4>
                                <mat-form-field class="mrgn drpdown-chart-options duration-dropdown form-field"
                                    appearance="outline">
                                    <mat-select [(ngModel)]="usageAnalyticsSelectedValue" name="usageEramAnalytics"
                                        (selectionChange)="changeAnalytics($event.value)">
                                        <mat-option class="drp-options" *ngFor="let ua of usageEramAnalytics"
                                            [value]="ua.value">
                                            {{ua.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div fxLayout="column">
                            <i class="fa fa-share-square-o" aria-hidden="true"
                                style="font-size: 24px;margin-top:10px; color: #707070; cursor: pointer;"
                                (click)="exportCsvData('usage')"></i>
                        </div>
                    </div>
                </nav>
            </article>
        </mat-card-header>
        <mat-card-content class="flx_tm">
            <!-- <mat-spinner *ngIf="!sessionPlayedChartDatasets" diameter="20" ngClass="loader"></mat-spinner> -->
            <app-highcharts [totalLessionsSessions]="totalLessionsSessions" [updateChart]="updateChart">
            </app-highcharts>
        </mat-card-content>
    </mat-card>
</div>
<!-- SG-7046 end -->